import React from 'react'
import { makeStyles, Grid, Typography, Chip, Link } from '@material-ui/core'
import Image from 'next/image'

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#211A29',
    padding: '80px 20px',
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      padding: '80px 120px',
    },
  },
  header: {
    color: 'white',
    margin: '1rem 0',
    letterSpacing: '-0.02em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '52px',
    },
  },
  chip: {
    background: 'rgba(11, 11, 11, 0.8)',
    color: 'white',
  },
  link: {
    color: 'white',
    fontSize: '.8rem',
    padding: '.4rem 0',
    borderBottom: '1px solid white',
  },
  contentSection: {
    margin: '1rem 0',
    '& p': {
      color: 'white',
    },
  },
  contentCard: {
    background: 'rgba(255, 255, 255, 0.06)',
    borderRadius: '.8rem',
    padding: '2rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minHeight: '14rem',
    '& .title': {
      fontSize: '1.2rem',
      fontWeight: '600',
    },
    '& .body': {
      color: theme.palette.text.secondary,
      fontSize: '1rem',
    },
  },
  cardBody: {
    fontSize: '1rem',
  },
  cardHeader: {
    margin: '0 0 1rem 0',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  whiteText: {
    color: 'white',
  },
}))

export default function WalletGuide(): JSX.Element {
  const classes = useStyles({})
  return (
    <div className={classes.root}>
      <Chip label="Wallet guide" className={classes.chip} />
      <Typography variant="h1" className={classes.header}>
        Custodial vs non-custodial wallets
      </Typography>
      <Link className={classes.link} underline="none">
        See the whole guide
      </Link>
      <div>
        <Grid container className={classes.contentSection} spacing={2}>
          <Grid item xs={12} md={6}>
            <div className={classes.contentCard}>
              <div>
                <Image src="/svg/custodial.svg" layout="intrinsic" height={64} width={64} />
              </div>
              <Typography variant="body2" className="body">
                <span className={classes.whiteText}>Custodial wallets</span> are like banks. They
                are provided by a centralized entity who controls your assets and saves them for
                you. If you want to move funds out of your custodial wallet you need to request a
                withdrawal. Importantly, with a custodial wallet you can’t access decentralized
                applications (dApps) on the blockchain.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={classes.contentCard}>
              <div>
                <Image src="/svg/non-custodial.svg" layout="intrinsic" height={64} width={64} />
              </div>
              <Typography variant="body2" className="body">
                <span className={classes.whiteText}>Non-custodial wallets</span> allow you to keep
                complete ownership of your funds. Holding crypto assets in a non-custodial wallet is
                the equivalent of holding cash in the real world. Your funds are stored on the
                Blockchain and you have direct control over them. Most wallets allow you to hold,
                send & receive funds on multiple blockchains.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
